'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.h = h;

var _is = require('snabbdom/is');

var _is2 = _interopRequireDefault(_is);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vnode = require('snabbdom/vnode');

function isStream(stream) {
  return typeof stream.observe === 'function';
}

function mutateStreamWithNS(vNode) {
  addNS(vNode.data, vNode.children);
  return vNode;
}

function addNS(data, children) {
  // eslint-disable-line complexity
  data.ns = 'http://www.w3.org/2000/svg';
  if (typeof children !== 'undefined' && _is2.default.array(children)) {
    for (var i = 0; i < children.length; ++i) {
      if (isStream(children[i])) {
        children[i] = children[i].tap(mutateStreamWithNS);
      } else {
        addNS(children[i].data, children[i].children);
      }
    }
  }
}

function h(sel, b, c) {
  // eslint-disable-line complexity
  var data = {};
  var children = void 0;
  var text = void 0;
  var i = void 0;
  if (arguments.length === 3) {
    data = b;
    if (_is2.default.array(c)) {
      children = c;
    } else if (_is2.default.primitive(c)) {
      text = c;
    }
  } else if (arguments.length === 2) {
    if (_is2.default.array(b)) {
      children = b;
    } else if (_is2.default.primitive(b)) {
      text = b;
    } else {
      data = b;
    }
  }
  if (_is2.default.array(children)) {
    children = children.filter(function (x) {
      return x;
    }); // handle null/undef children
    for (i = 0; i < children.length; ++i) {
      if (_is2.default.primitive(children[i])) {
        children[i] = vnode(undefined, undefined, undefined, children[i]);
      }
    }
  }
  if (sel[0] === 's' && sel[1] === 'v' && sel[2] === 'g') {
    addNS(data, children);
  }
  return vnode(sel, data, children, text, undefined);
};


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/hyperscript/h.js
 **/